enum PunchhOloPhoneSlug {
  PunchhPhoneNumber = 'punchh-phone-number',
  PunchhKiosk = 'punchh-kiosk',
  PunchhMsPhoneNumber = 'punchhms-phone-number',
  PunchhDqUsPhoneNumber = 'punchhdq-us-phone-number',
}

export { PunchhOloPhoneSlug };
